<script lang="ts" setup>
import userIcon from '@/assets/img/nav/user-circle.svg';
import { useAuthStore } from '@/modules/auth/store/auth';
import type { SidebarMenu } from '@/types/SidebarMenu';
import { AUTH_ROUTES, GUEST_ROUTES } from '@/utils/constants/Menu';
import { storeToRefs } from 'pinia';

interface Props {
  prependMenu?: SidebarMenu[];
  appendMenu?: SidebarMenu[];
}
const { prependMenu = [], appendMenu = [] } = defineProps<Props>();

const { user } = storeToRefs(useAuthStore());

const accountMenu = computed((): SidebarMenu => {
  return {
    title: user.value?.full_name || 'Account',
    icon: userIcon,
    link: { name: 'account' },
    class: 'bottom-menu',
  };
});

const navigations = computed((): SidebarMenu[] => {
  const menus = [];

  if (!user.value.employee?.is_account_owner) {
    AUTH_ROUTES.splice(
      AUTH_ROUTES.findIndex((menu) => menu.link?.name === 'admin-employees'),
      1
    );
  }

  const authRoutes = [...AUTH_ROUTES, accountMenu.value];
  const guesRoutes = [...GUEST_ROUTES];

  if (user.value && Object.keys(user.value).length) {
    menus.push(...authRoutes);
  } else {
    menus.push(...guesRoutes);
  }

  return [...prependMenu, ...menus, ...appendMenu];
});
</script>
<template>
  <v-list rounded="100" class="pa-0 text-subtitle-2 h-100">
    <template v-for="(navigation, index) in navigations" :key="index">
      <v-list-item
        :data-cy="`menu-${navigation.link?.name}`"
        class="px-4 py-2"
        :class="navigation.class ? navigation.class : ''"
        :to="navigation.link || undefined"
        @click="navigation.action ? navigation.action() : null"
      >
        <template v-if="navigation.icon" #prepend>
          <v-icon v-if="navigation.mdi"> {{ navigation.icon }}</v-icon>
          <v-img v-else :src="navigation.icon" width="20px" height="20px" class="mr-4"></v-img>
        </template>
        <v-list-item-title :class="{ 'ml-10': !navigation.icon }">
          <span class="text-subtitle-2">
            {{ navigation.title }}
          </span>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-list>
</template>
<style lang="scss" scoped>
.v-list {
  .v-list-item--active {
    background: #ffffff0a;
    border-radius: 12px !important;
  }
  .bottom-menu {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  :deep(.v-list-item) {
    .v-list-item-title {
      * {
        color: rgb(var(--v-theme-white));
      }
    }
  }
}
</style>
